/** Normaliza fulfillment de producto/pedido para operación admin. */
export function normalizeFulfillment(value) {
  const f = String(value || '').trim().toLowerCase();
  if (['dropshipping', 'supplier', 'proveedor'].includes(f)) {
    return 'dropshipping';
  }
  return 'javiland';
}

export function isDropshipping(value) {
  return normalizeFulfillment(value) === 'dropshipping';
}

export function fulfillmentLabel(value) {
  return isDropshipping(value) ? 'Dropshipping' : 'Bodega Chía';
}

export function fulfillmentSummaryLabel(summary) {
  if (summary === 'mixed') return 'Mixto';
  return fulfillmentLabel(summary);
}

export function buildDropshipWhatsAppMessage(order) {
  const items = (order.items || []).filter((line) => isDropshipping(line.fulfillment));
  const productLines = items.length
    ? items.map((line) => `• ${line.quantity}x ${line.product_name}`).join('\n')
    : '• (sin líneas dropshipping en esta orden)';

  const addressParts = [
    order.shipping_address,
    order.shipping_city,
    order.shipping_department,
    order.shipping_postal_code
  ].filter((part) => part != null && String(part).trim() !== '');

  const address = addressParts.length ? addressParts.join(', ') : '—';

  return [
    'Hola, nuevo pedido Javiland (dropshipping):',
    '',
    `Orden: ${order.order_number || `#${order.id}`}`,
    `Cliente: ${order.customer_name || '—'}`,
    `Email: ${order.customer_email || '—'}`,
    `Tel: ${order.customer_phone || '—'}`,
    '',
    'Productos:',
    productLines,
    '',
    'Enviar a:',
    address,
    '',
    'Gracias.'
  ].join('\n');
}
